import { render, staticRenderFns } from "./Yach4Customer.vue?vue&type=template&id=d8c4b9a0&"
import script from "./Yach4Customer.vue?vue&type=script&lang=js&"
export * from "./Yach4Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports